import { render, staticRenderFns } from "./HorizontalBarChart.vue?vue&type=template&id=54480156"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54480156')) {
      api.createRecord('54480156', component.options)
    } else {
      api.reload('54480156', component.options)
    }
    module.hot.accept("./HorizontalBarChart.vue?vue&type=template&id=54480156", function () {
      api.rerender('54480156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Visualisations/HorizontalBarChart.vue"
export default component.exports